var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobOpportunities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1289 515.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Surface",
    x: 0,
    y: 83.426,
    width: 1289,
    height: 432,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734",
    transform: "translate(4.5 -68.074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 68.07)",
    filter: "url(#Surface)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Surface-2",
    "data-name": "Surface",
    width: 1280,
    height: 423,
    rx: 4,
    transform: "translate(4.5 86.93)",
    fill: "#edeefc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1718",
    "data-name": "Group 1718",
    transform: "translate(-258.088 -162.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1709",
    "data-name": "Group 1709",
    transform: "translate(1181.436 230.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M1860.01,245.321s12.976-14.155,16.986-14.627,20.525,7.439,21.469,10.561-18.166-3.122-19.228,0-2.241,5.245-7.667,5.481a22.9,22.9,0,0,0-10.145,3.3Z",
    transform: "translate(-1788.605 -230.674)",
    fill: "#e9a4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M1745.4,1409.578c4.123-2.517,1.777-21.291,1.777-21.291s-19.213-15.371-21.854-3.6-18.253,17.051-27.139,18.493c-6.134.995-8.033,4.392-8.621,6.4Z",
    transform: "translate(-1689.566 -898.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M1796.6,1051.053c4.923-1.857,32.338-67.664,31.2-89.033-.137-2.535.359-23.328,1.14-27.636.609-3.356,1.424-7.265,2.4-11.6,1.5-6.6,3.368-14.205,5.448-22.359,5.829-22.912,13.254-50.155,18.376-71.842-9.191-20.61-20.969-38.65-31.772-44.81-7.71.941-15.14,2.365-20.645,3.556a96.834,96.834,0,0,0-10.1,6.661c-.855,4.273-2.1,11.4-3.111,20.581-.65,6.006-1.2,12.894-1.453,20.428-1.829,53.454,7.516,111.541-16.313,206.351C1771.112,1043.994,1788.981,1053.931,1796.6,1051.053Z",
    transform: "translate(-1737.327 -552.061)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M1814.213,814.571c3.971,19.875,13.527,62.348,47.248,85.853,5.829-22.912,13.254-50.155,18.376-71.842-9.191-20.61-20.969-38.65-31.772-44.81-7.71.941-15.14,2.365-20.645,3.556a96.837,96.837,0,0,0-10.1,6.661C1816.469,798.263,1815.222,805.392,1814.213,814.571Z",
    transform: "translate(-1761.995 -552.061)",
    fill: "#242c4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M1913.048,384.289l.018,3.334s-.908,10.427,11.931,11.949,22.565-4.066,22.217-12.111c-1.156-6.23-2.426-10.508-2.512-15.662a36.352,36.352,0,0,1,.456-6.243l-24.878-.5-7.328,1.2Z",
    transform: "translate(-1819.369 -308.76)",
    fill: "#e9a4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M1912.953,366.255l.1,18.034a21.033,21.033,0,0,0,8.967,1.979c11.434,0,18.825-8.385,22.687-14.47a36.352,36.352,0,0,1,.456-6.243l-24.878-.5Z",
    transform: "translate(-1819.369 -308.76)",
    fill: "#d998a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M1901.852,315.889s31.862,6.436,35.565-13.467,10.309-32.478-9.877-37.429-25.564,1.907-28.416,8.249S1893.659,313.7,1901.852,315.889Z",
    transform: "translate(-1809.719 -249.63)",
    fill: "#e9a4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M1964.246,1425.087s1.74-9.526,4.5-15.041,20.3-2.005,20.3-2.005,3.509,3.008,4.262,17.046Z",
    transform: "translate(-1849.173 -914.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M1882.171,797.562s17.465,77.819,23.064,112.944c2.095,13.142,6.46,55.249,7.141,68.54.936,18.239,6.95,74.062,6.95,74.062s10.145-6.411,25.2-.427c0,0,3.8-25.022,6.22-77.433.709-15.364-2.26-38.441-1.9-45.936,1.773-36.856,13.547-132.149,4.185-138.265S1882.171,797.562,1882.171,797.562Z",
    transform: "translate(-1801.483 -555.316)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M1887.909,242.386a66.774,66.774,0,0,0,19.365-5.24c8.505-3.7,19.237.375,22.721,2.21a5.179,5.179,0,0,0-.85-2.1,4.676,4.676,0,0,1,1.795,2.659c.161.119.233.2.191.228a6,6,0,0,1,2.913.189s-.8-.114-1.082.4a.49.49,0,0,1-.128.141c13.268,6.411,14.494,27.381,10.224,32.233-5.137,5.838-11.3,18.984-11.3,18.984a11.266,11.266,0,0,1-1.312-8.243c.934-5.137-3.5-5.137-9.107-7.472s-.934-8.873-5.837-12.842-22.884-1.635-22.651-4.67C1886.18,256.433,1887.909,243.07,1887.909,242.386Z",
    transform: "translate(-1804.7 -233.562)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M1778.791,249.2a9.028,9.028,0,0,1,4.3,4.883c2.063,4.855.382,7.5.382,7.5s-33.721,30.582-31.528,36.148c1.145,2.908,27.271,18.227,38.126,24.5,4.464-.373,7.919-.341,8.029-.341l.006.006s7.384,22.5,33.829-1.755c4.644,6.758,40.65,23.351,34.4,51.989q-2.206,10.094-3.835,19.066c-7.43,40.576-6.849,64.514-5.4,77.716,1.128,10.3,5.4,11.339,1.578,14.08,0,0-7.436,3.333-21.351,6.216a210.923,210.923,0,0,1-41.363,4.154c-27.2.171-37.5-9.2-37.5-9.2-7.2-7.043,7.042-34.758,5.9-54.764-.586-10.263.058-45.4.158-61.547l-.01-.01-.023-.023c-1.3-1.43-41.1-45.215-48.935-70.07,0-.006-.006-.006-.006-.011a32.907,32.907,0,0,1-.929-3.607C1712.243,281.9,1778.791,249.2,1778.791,249.2Z",
    transform: "translate(-1704.087 -241.439)",
    fill: "#22d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M2034.612,652.712c-1.447-13.2-2.029-37.14,5.4-77.716q-.763-2.421-1.513-4.646a7.1,7.1,0,0,0-13.6.48C2019.413,592.06,2014.469,628.15,2034.612,652.712Z",
    transform: "translate(-1881.605 -425.238)",
    fill: "#24b581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M2022.514,708.442s-16.539-10-21.665-8.731-16.247,6.1-15.557,9.056,13.608,4.972,15.856,4.624,5.876.06,7.35,1.331,13.194,1.745,14.624-1.686S2022.514,708.442,2022.514,708.442Z",
    transform: "translate(-1861.385 -503.151)",
    fill: "#e9a4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M1994.734,418.533s20.276,1.469,31.292,7.926c7.128,4.179,48.434,69.992,48.434,79.679s-43.376,44.05-43.376,44.05-8.05,2.674-8.335-10.146c0,0,21.637-31.984,20.5-35.688-.716-2.327-32.6-27.908-32.6-27.908Z",
    transform: "translate(-1866.889 -339.833)",
    fill: "#22d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M1716.936,365.085c7.835,24.855,47.63,68.639,48.935,70.069l.023.023.011.011a.016.016,0,0,1,.006-.011c.114-.439,3.4-12.963-4.439-21.921C1753.495,404.14,1725.967,381.291,1716.936,365.085Z",
    transform: "translate(-1705.47 -308.776)",
    fill: "#24b581"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1708",
    "data-name": "Group 1708",
    transform: "translate(73.046 75.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M1966.586,421.676c.087-1.757-8.235-4.185-8.235-4.185s-9.524,13.206-25.217,13.435c0,0,4.472,8.7,9.743,10.956C1942.878,441.882,1966.068,432.109,1966.586,421.676Z",
    transform: "translate(-1904.142 -414.927)",
    fill: "#22d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M1909.877,434.468s-8.313-4.928-8.342-10.271c0,0-5.369-.672-7.714,1.932,0,0-1.971,9.156.644,14.475C1894.465,440.6,1906.436,438.78,1909.877,434.468Z",
    transform: "translate(-1880.884 -418.778)",
    fill: "#22d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M1864.019,577.587a17.369,17.369,0,0,0,4.94,11.5l4.746,4.854a2.924,2.924,0,0,0,4.291-.119l6.587-7.521a10.43,10.43,0,0,0,2.57-7.316c-.267-5.966-.747-17.459-1.031-28.542-.233-8.98-.341-17.7-.108-22.986.746-16.883,6.906-70.525,6.906-70.525h-4.057a217.013,217.013,0,0,0-17.886,48.513,188.327,188.327,0,0,0-3.954,22.012S1863.306,558.088,1864.019,577.587Z",
    transform: "translate(-1863.928 -437.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M1928.983,443.183l-11.273-2.7a1.708,1.708,0,0,0-1.431,1.964c.04,1.836,3.175,7.2,4.563,7.63S1931.65,446.9,1928.983,443.183Z",
    transform: "translate(-1894.347 -428.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M1966.586,415.554c.087-1.757-8.235-4.184-8.235-4.184s-9.524,13.206-25.217,13.435c0,0,4.472,8.7,9.743,10.956C1942.878,435.761,1966.068,425.988,1966.586,415.554Z",
    transform: "translate(-1904.142 -411.37)",
    fill: "#22d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M1909.877,429.084s-8.313-4.928-8.342-10.271c0,0-5.369-.672-7.714,1.931,0,0-1.971,9.157.644,14.475C1894.465,435.219,1906.436,433.4,1909.877,429.084Z",
    transform: "translate(-1880.884 -415.65)",
    fill: "#22d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M1864.019,644.875a17.369,17.369,0,0,0,4.94,11.5l4.746,4.854a2.923,2.923,0,0,0,4.291-.119l6.587-7.522a10.429,10.429,0,0,0,2.57-7.316c-.267-5.966-.747-17.459-1.031-28.542-10.524-13.145-14.148-30.741-15.145-45a188.33,188.33,0,0,0-3.954,22.012S1863.306,625.376,1864.019,644.875Z",
    transform: "translate(-1863.928 -505.135)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711",
    transform: "translate(1349.144 674.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_913",
    "data-name": "Rectangle 913",
    d: "M16.321,0H66.3A16.321,16.321,0,0,1,82.623,16.321V43.676A16.322,16.322,0,0,1,66.3,60H16.322A16.322,16.322,0,0,1,0,43.676V16.321A16.321,16.321,0,0,1,16.321,0Z",
    transform: "translate(82.623 67.264) rotate(-180)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    width: 82.622,
    height: 60.001,
    rx: 16.321,
    transform: "translate(6.268 7.265)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710",
    transform: "translate(34.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M2200.545,1296.961c-4.411-5.212-10.155-7.265-13.83-7.265-8.99,0-14.009,7-14.2,7.265l2.19.146c.161-.228,3.718-4.7,11.485-4.7,3.192,0,7.876.014,11.722,4.558C2198.163,1297.255,2200.6,1297.025,2200.545,1296.961Z",
    transform: "translate(-2172.518 -1289.696)",
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    d: "M13.569,0H69.052a13.57,13.57,0,0,1,13.57,13.57v0a13.57,13.57,0,0,1-13.57,13.57H13.569A13.569,13.569,0,0,1,0,13.571v0A13.569,13.569,0,0,1,13.569,0Z",
    transform: "translate(6.268 9.165)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_916",
    "data-name": "Rectangle 916",
    d: "M13.57,0H69.051A13.571,13.571,0,0,1,82.622,13.571v0a13.57,13.57,0,0,1-13.57,13.57H13.571A13.571,13.571,0,0,1,0,13.57v0A13.57,13.57,0,0,1,13.57,0Z",
    transform: "translate(6.268 7.265)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M2205.6,1356.28a2.089,2.089,0,1,0-2.089,2.089A2.089,2.089,0,0,0,2205.6,1356.28Z",
    transform: "translate(-2154.695 -1327.171)",
    fill: "#c5c9f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1717",
    "data-name": "Group 1717",
    transform: "translate(815.088 310.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M1193.869,547.238V916a5.858,5.858,0,0,0,5.623,6.034h5.623a5.416,5.416,0,0,0,3.962-1.765,6.247,6.247,0,0,0,1.661-4.269V547.238a6.132,6.132,0,0,0-2.684-5.134,5.271,5.271,0,0,0-2.939-.9h-5.623A5.855,5.855,0,0,0,1193.869,547.238Z",
    transform: "translate(-1035.185 -490.784)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M1223.773,547.621V916.388a6.144,6.144,0,0,0,2.681,5.134,6.247,6.247,0,0,0,1.661-4.269V548.486a6.132,6.132,0,0,0-2.685-5.134A6.242,6.242,0,0,0,1223.773,547.621Z",
    transform: "translate(-1052.561 -492.032)",
    fill: "#adb1df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M1284.655,899.128l31.124,20.978-28.223,24.744-69.851-4.4V912.229Z",
    transform: "translate(-1049.035 -698.761)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712",
    transform: "translate(0 143.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2950",
    "data-name": "Path 2950",
    d: "M880.589,763.063,831.953,784l46.767,24.836,111.918-3.888V770.017Z",
    transform: "translate(-824.888 -763.063)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2951",
    "data-name": "Path 2951",
    d: "M870.789,763.063h-7.065L815.088,784h7.065Z",
    transform: "translate(-815.088 -763.063)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2952",
    "data-name": "Path 2952",
    d: "M868.92,837.883h-3.766l-50.067-24.836h7.065Z",
    transform: "translate(-815.088 -792.107)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2953",
    "data-name": "Path 2953",
    d: "M1192.926,790.755a4.13,4.13,0,0,0,.29,3.432c.569.792,1.361.54,1.77-.563a4.134,4.134,0,0,0-.29-3.432C1194.126,789.4,1193.334,789.652,1192.926,790.755Z",
    transform: "translate(-1034.498 -778.558)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2954",
    "data-name": "Path 2954",
    d: "M1192.926,841.847a4.13,4.13,0,0,0,.29,3.432c.569.792,1.361.54,1.77-.563a4.132,4.132,0,0,0-.29-3.432C1194.126,840.491,1193.333,840.744,1192.926,841.847Z",
    transform: "translate(-1034.498 -808.246)",
    fill: "#c5c9f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713",
    transform: "translate(165.75 82.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2955",
    "data-name": "Path 2955",
    d: "M1320.784,618.464l48.636,20.94-46.766,24.836-111.918-3.888V625.418Z",
    transform: "translate(-1210.735 -618.464)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2956",
    "data-name": "Path 2956",
    d: "M1473.424,618.464h7.065l48.636,20.94h-7.065Z",
    transform: "translate(-1363.375 -618.464)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2957",
    "data-name": "Path 2957",
    d: "M1477.886,693.284h3.765l50.066-24.836h-7.065Z",
    transform: "translate(-1365.968 -647.508)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2958",
    "data-name": "Path 2958",
    d: "M1225.027,646.156a4.134,4.134,0,0,1-.29,3.432c-.569.793-1.362.54-1.77-.563a4.134,4.134,0,0,1,.29-3.432C1223.827,644.8,1224.619,645.053,1225.027,646.156Z",
    transform: "translate(-1217.705 -633.96)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M1225.027,697.248a4.134,4.134,0,0,1-.29,3.432c-.569.793-1.362.54-1.77-.563a4.134,4.134,0,0,1,.29-3.432C1223.827,695.893,1224.619,696.145,1225.027,697.248Z",
    transform: "translate(-1217.705 -663.648)",
    fill: "#c5c9f6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M1377.516,899.128h4.031l33.053,21.164h-5.96Z",
    transform: "translate(-1141.896 -698.761)",
    fill: "#adb1df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M1384.441,974.2h5.429l28.753-24.559h-5.959Z",
    transform: "translate(-1145.92 -728.115)",
    fill: "#adb1df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M1163.975,1329.907v41.619H1205.9v-41.779a14.986,14.986,0,0,0-13.431-14.906,15.283,15.283,0,0,0-1.555-.08h-11.786A15.147,15.147,0,0,0,1163.975,1329.907Z",
    transform: "translate(-1017.815 -940.271)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M1199.574,1330.018v41.619h27.007v-41.779a14.985,14.985,0,0,0-13.431-14.906A15.15,15.15,0,0,0,1199.574,1330.018Z",
    transform: "translate(-1038.5 -940.382)",
    fill: "#adb1df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1716",
    "data-name": "Group 1716",
    transform: "translate(150.701 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2964",
    "data-name": "Path 2964",
    d: "M1203.312,511.262V509.81h-3.7v.023a4.232,4.232,0,0,0-2.621,1.223,4.257,4.257,0,0,0,.031,6.11,4.249,4.249,0,0,0,3.07,1.277h3.223v-1.452a4.489,4.489,0,0,0,0-5.73Z",
    transform: "translate(-1186.957 -472.542)",
    fill: "#adb1df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2965",
    "data-name": "Path 2965",
    d: "M1198.282,424.194a14.73,14.73,0,0,0-9.85-3.344,15.608,15.608,0,0,0-7.174,1.732,12.74,12.74,0,0,0-5.289,4.894,7.572,7.572,0,0,0-1.155,3.891,3.538,3.538,0,0,0,.943,2.523,3.151,3.151,0,0,0,2.4,1h3.223s-.039-1.209-.041-2.036l2.229-3.01a7.062,7.062,0,0,1,8.846-.4,4.708,4.708,0,0,1,1.672,3.861,5.65,5.65,0,0,1-1.764,4.438,12.1,12.1,0,0,1-4.377,2.128,8.021,8.021,0,0,0-3.07,1.49,3.092,3.092,0,0,0-.76,2.279v6.08a4.705,4.705,0,0,0,.973,3.04,3.3,3.3,0,0,0,2.736,1.216h3.223v-1.842a4.868,4.868,0,0,0,.365-.954,29.233,29.233,0,0,0,.242-4.986,13.5,13.5,0,0,0,7.874-4.286,12.267,12.267,0,0,0,2.887-8.36A11.809,11.809,0,0,0,1198.282,424.194Z",
    transform: "translate(-1174.814 -420.85)",
    fill: "#adb1df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(3.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2966",
    "data-name": "Path 2966",
    d: "M1210.11,433.556a12.264,12.264,0,0,1-2.888,8.36,13.494,13.494,0,0,1-7.874,4.286,29.046,29.046,0,0,1-.243,4.986,3.383,3.383,0,0,1-3.587,2.8,3.3,3.3,0,0,1-2.736-1.216,4.708,4.708,0,0,1-.973-3.04v-6.08a3.094,3.094,0,0,1,.76-2.279,8.024,8.024,0,0,1,3.07-1.49,12.1,12.1,0,0,0,4.377-2.128,5.652,5.652,0,0,0,1.764-4.438,4.707,4.707,0,0,0-1.672-3.861,7.063,7.063,0,0,0-8.847.4l-2.431,3.283a3.654,3.654,0,0,1-2.979,1.763,3.15,3.15,0,0,1-2.4-1,3.538,3.538,0,0,1-.942-2.523,7.573,7.573,0,0,1,1.155-3.891,12.738,12.738,0,0,1,5.29-4.894,15.606,15.606,0,0,1,7.174-1.732,14.727,14.727,0,0,1,9.848,3.344A11.808,11.808,0,0,1,1210.11,433.556ZM1199.9,462.435a4.227,4.227,0,0,1-1.216,3.07,4.075,4.075,0,0,1-3.04,1.246,4.25,4.25,0,0,1-3.07-1.277,4.256,4.256,0,0,1-.031-6.109,4.275,4.275,0,0,1,3.1-1.247,4.074,4.074,0,0,1,3.04,1.247A4.227,4.227,0,0,1,1199.9,462.435Z",
    transform: "translate(-1182.508 -420.85)",
    fill: "#c5c9f6"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobOpportunities);
export default __webpack_public_path__ + "static/media/job-opportunities.7453e70dc50548134dce3d98c7287506.svg";
export { ForwardRef as ReactComponent };